import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { observable, reaction } from 'mobx';
import { useEffect } from 'react';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';

class MapStore extends BaseStore {
  @observable tabIndex = -1;
  @observable playNextDuration = 16000; // 自动播放下一张的时间间隔
  @observable slidesData = [];
  @observable isShowFooter = false;

  timer = null;
  swiperStore = new BaseSwiperStore({
    swiperOptions: {
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false
    }
  });

  changeTab = index => {
    this.tabIndex = index;
    this.playNextDuration = 16000 / (index + 1);
    this.playSwiper();
  };

  playSwiper = () => {
    this.tabIndex = 0;
    // clearInterval(this.timer);
    // this.timer = setInterval(() => {
    //   this.playNextDuration -= 30;
    //   this.tabIndex = +!parseInt(this.playNextDuration / 8000, 10);
    //   if (this.playNextDuration <= 0) {
    //     this.playNextDuration = 16000;
    //   }
    // }, 30);
  };

  playPrev = () => {
    this.changeSwiper(this.swiperStore.activeIndex - 1 < 0 ? this.slidesData.length - 1 : this.swiperStore.activeIndex - 1);
  };

  playNext = () => {
    this.changeSwiper(this.swiperStore.activeIndex + 1 > this.slidesData.length - 1 ? 0 : this.swiperStore.activeIndex + 1);
  };

  changeSwiper = index => {
    clearInterval(this.timer);
    this.playNextDuration = 16000;
    this.tabIndex = -1;
    this.swiperStore.onChange(index);
  };

  use() {
    super.use();

    const pageData = useFunLinkPageData();
    useEffect(
      () => {
        if (pageData) {
          let mapContent = pageData.contentList || [];
          this.slidesData = (pageData.mapList || []).map(item => {
            return {
              ...item,
              contentList: mapContent.filter(child => item.mapCode === child.mapContentCode)
            };
          });
        }
      },
      [pageData]
    );

    useMount(() => {
      this.playSwiper();
      reaction(
        () => this.swiperStore.activeIndex,
        () => {
          this.playSwiper();
        }
      );
      return () => {
        clearInterval(this.timer);
      };
    });
  }
}

export default MapStore;
